import { Auth } from "aws-amplify";

const confirmEmail = async (email: string, code: string) => {
  await Auth.confirmSignUp(email, code);
};

export default confirmEmail;
